// extracted by mini-css-extract-plugin
module.exports = {"input":"form-input_input_1jdcf"};